<div class="bdur-page">
  <header class="bdur-header">
    <button class="bdur-btn-ghost" (click)="cancel()">
      <mat-icon>arrow_back</mat-icon> Volver al listado
    </button>
    <h1>
      <mat-icon>group_add</mat-icon>
      Nueva solicitud masiva
    </h1>
    <p>
      Creá una solicitud por cada cliente seleccionado, con plazo y motivo comunes.
      Si un usuario falla la validación, no se crea ninguna.
    </p>
  </header>

  <!-- ═══ Paso 1: selección de usuarios ═══ -->
  <ng-container *ngIf="step === 'select'">
    <section class="bdur-toolbar">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (keyup.enter)="applySearch()"
        placeholder="ID de usuario, nombre o número de documento..."
        class="bdur-input"
      />
      <button class="bdur-btn bdur-btn--ghost" (click)="applySearch()">
        <mat-icon>search</mat-icon> Buscar
      </button>

      <!-- Filtros combinables — se mandan al backend como query params.
           Todos aplican con AND entre sí; la búsqueda por texto se
           combina encima. Cambio de filtro resetea a page=1. -->
      <select
        [ngModel]="filterCompliance"
        (ngModelChange)="filterCompliance = $event; applyFilters()"
        class="bdur-input bdur-input--select"
        title="Filtrar por estado compliance"
      >
        <option value="all">Compliance: todos</option>
        <option value="aprobado">Aprobado</option>
        <option value="por_aprobar">Por aprobar</option>
        <option value="rechazado">Rechazado</option>
        <option value="blacklist">Blacklist</option>
        <option value="bloqueado">Bloqueado</option>
        <option value="desconocido">Sin dato</option>
      </select>
      <select
        [ngModel]="filterTipo"
        (ngModelChange)="filterTipo = $event; applyFilters()"
        class="bdur-input bdur-input--select"
        title="Filtrar por tipo de usuario"
      >
        <option value="all">Tipo: todos</option>
        <option value="persona">Persona</option>
        <option value="empresa">Empresa</option>
      </select>

      <!-- Rango de fecha de creación del usuario. `createdTo` no puede
           ser anterior a `createdFrom`, y ambos limitados a hoy. -->
      <label class="bdur-date-filter" title="Usuarios creados desde">
        Desde
        <input
          type="date"
          [ngModel]="filterCreatedFrom"
          (ngModelChange)="filterCreatedFrom = $event; applyFilters()"
          [max]="filterCreatedTo || todayIsoDate"
          class="bdur-input bdur-input--date"
          onclick="this.showPicker && this.showPicker()"
          onfocus="this.showPicker && this.showPicker()"
        />
      </label>
      <label class="bdur-date-filter" title="Usuarios creados hasta">
        Hasta
        <input
          type="date"
          [ngModel]="filterCreatedTo"
          (ngModelChange)="filterCreatedTo = $event; applyFilters()"
          [min]="filterCreatedFrom"
          [max]="todayIsoDate"
          class="bdur-input bdur-input--date"
          onclick="this.showPicker && this.showPicker()"
          onfocus="this.showPicker && this.showPicker()"
        />
      </label>

      <!-- Documentos faltantes — chips toggleables. `any` es exclusivo. -->
      <div class="bdur-missing-docs" title="Filtrar por documentos faltantes">
        <span class="bdur-missing-docs__label">Sin documento:</span>
        <button
          type="button"
          class="bdur-missing-docs__chip"
          [class.bdur-missing-docs__chip--active]="isMissingDocSelected('any')"
          (click)="toggleMissingDoc('any')"
        >
          Alguno
        </button>
        <button
          type="button"
          class="bdur-missing-docs__chip"
          [class.bdur-missing-docs__chip--active]="isMissingDocSelected('fotoIdfrontal')"
          [disabled]="isMissingDocSelected('any')"
          (click)="toggleMissingDoc('fotoIdfrontal')"
        >
          Frontal
        </button>
        <button
          type="button"
          class="bdur-missing-docs__chip"
          [class.bdur-missing-docs__chip--active]="isMissingDocSelected('fotoIdPosterior')"
          [disabled]="isMissingDocSelected('any')"
          (click)="toggleMissingDoc('fotoIdPosterior')"
        >
          Reverso
        </button>
        <button
          type="button"
          class="bdur-missing-docs__chip"
          [class.bdur-missing-docs__chip--active]="isMissingDocSelected('selfie')"
          [disabled]="isMissingDocSelected('any')"
          (click)="toggleMissingDoc('selfie')"
        >
          Selfie
        </button>
      </div>

      <button
        *ngIf="hasActiveFilters"
        class="bdur-btn bdur-btn--ghost"
        (click)="resetFilters()"
        title="Limpiar todos los filtros"
      >
        <mat-icon>filter_alt_off</mat-icon>
        Limpiar filtros
      </button>

      <div class="bdur-toolbar__spacer"></div>
      <span class="bdur-selected-pill" *ngIf="selectedCount > 0">
        <mat-icon>group</mat-icon>
        {{ selectedCount }} seleccionado(s)
        <button class="bdur-pill-clear" (click)="clearSelection()" title="Limpiar selección">
          <mat-icon>close</mat-icon>
        </button>
      </span>
      <button
        class="bdur-btn bdur-btn--primary"
        [disabled]="selectedCount === 0 || preparingMatrix"
        (click)="proceedToMatrix()"
      >
        <mat-spinner *ngIf="preparingMatrix" diameter="16"></mat-spinner>
        <ng-container *ngIf="!preparingMatrix">
          Continuar
          <mat-icon>arrow_forward</mat-icon>
        </ng-container>
        <span *ngIf="preparingMatrix">Preparando matriz...</span>
      </button>
    </section>

    <section class="bdur-table-wrap">
      <div *ngIf="loading" class="bdur-loading">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Cargando usuarios...</span>
      </div>
      <div *ngIf="errorMessage && !loading" class="bdur-error">
        <mat-icon>error_outline</mat-icon> {{ errorMessage }}
        <button (click)="loadUsers()">Reintentar</button>
      </div>

      <table *ngIf="!loading && !errorMessage && rows.length" class="bdur-table">
        <thead>
          <tr>
            <th class="bdur-table__check">
              <input
                type="checkbox"
                [checked]="allVisibleSelected"
                [indeterminate]="someVisibleSelected"
                (change)="toggleSelectAllVisible()"
                title="Seleccionar todos los visibles"
              />
            </th>
            <!-- Headers clickeables — alternan asc → desc → sin orden. -->
            <th
              (click)="toggleSort('usuarioId')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'usuarioId'"
            >
              ID
              <mat-icon *ngIf="sortIndicator('usuarioId') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('usuarioId') === 'desc'">arrow_downward</mat-icon>
            </th>
            <th
              (click)="toggleSort('nombre')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'nombre'"
            >
              Usuario
              <mat-icon *ngIf="sortIndicator('nombre') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('nombre') === 'desc'">arrow_downward</mat-icon>
            </th>
            <th
              (click)="toggleSort('numeroId')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'numeroId'"
            >
              N° documento
              <mat-icon *ngIf="sortIndicator('numeroId') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('numeroId') === 'desc'">arrow_downward</mat-icon>
            </th>
            <th
              (click)="toggleSort('email')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'email'"
            >
              Email
              <mat-icon *ngIf="sortIndicator('email') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('email') === 'desc'">arrow_downward</mat-icon>
            </th>
            <th
              (click)="toggleSort('tipo')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'tipo'"
            >
              Tipo
              <mat-icon *ngIf="sortIndicator('tipo') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('tipo') === 'desc'">arrow_downward</mat-icon>
            </th>
            <th
              (click)="toggleSort('compliance')"
              class="bdur-th-sortable"
              [class.bdur-th-sortable--active]="sortBy === 'compliance'"
            >
              Compliance
              <mat-icon *ngIf="sortIndicator('compliance') === 'asc'">arrow_upward</mat-icon>
              <mat-icon *ngIf="sortIndicator('compliance') === 'desc'">arrow_downward</mat-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let u of visibleRows"
            (click)="toggleSelect(u, $event)"
            class="bdur-row"
            [class.bdur-row--selected]="isSelected(u.usuarioId)"
          >
            <td>
              <input
                type="checkbox"
                [checked]="isSelected(u.usuarioId)"
                (click)="$event.stopPropagation()"
                (change)="toggleSelect(u)"
              />
            </td>
            <td class="bdur-id">#{{ u.usuarioId }}</td>
            <td>{{ u.nombre }} {{ u.apellidos }}</td>
            <td>{{ u.numeroId }}</td>
            <td class="bdur-muted">{{ u.email }}</td>
            <td>
              <span class="bdur-badge" *ngIf="u.tipoUsuarioId === 1">Empresa</span>
              <span class="bdur-badge bdur-badge--person" *ngIf="u.tipoUsuarioId !== 1">Persona</span>
            </td>
            <td>
              <span
                class="bdur-compliance-chip"
                [ngClass]="'bdur-compliance-chip--' + complianceKey(u)"
              >
                {{ complianceLabel(u) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="!loading && !errorMessage && !rows.length" class="bdur-empty">
        Sin resultados.
      </div>
      <!-- Filtro dejó la vista vacía pero hay rows del backend. Mensaje
           distinto de "sin resultados de la búsqueda". -->
      <div
        *ngIf="!loading && !errorMessage && rows.length && !visibleRows.length"
        class="bdur-empty"
      >
        Ningún usuario coincide con los filtros aplicados.
      </div>
    </section>

    <footer class="bdur-pagination" *ngIf="rows.length">
      <label class="bdur-pagination__size">
        Por página:
        <select
          [ngModel]="limit"
          (ngModelChange)="changePageSize($event)"
          class="bdur-pagination__size-select"
        >
          <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{ opt }}</option>
        </select>
      </label>

      <div class="bdur-pagination__controls">
        <button
          class="bdur-btn bdur-btn--ghost bdur-btn--icon"
          (click)="firstPage()"
          [disabled]="!canGoPrev"
          title="Primera página"
          aria-label="Ir a la primera página"
        >
          <mat-icon>first_page</mat-icon>
        </button>
        <button
          class="bdur-btn bdur-btn--ghost"
          (click)="prevPage()"
          [disabled]="!canGoPrev"
        >
          <mat-icon>chevron_left</mat-icon> Anterior
        </button>
        <span class="bdur-pagination__info">
          Página {{ page }} de {{ totalPages }} · {{ total }} usuarios
        </span>
        <button
          class="bdur-btn bdur-btn--ghost"
          (click)="nextPage()"
          [disabled]="!canGoNext"
        >
          Siguiente <mat-icon>chevron_right</mat-icon>
        </button>
        <button
          class="bdur-btn bdur-btn--ghost bdur-btn--icon"
          (click)="lastPage()"
          [disabled]="!canGoNext"
          title="Última página"
          aria-label="Ir a la última página"
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </footer>
  </ng-container>

  <!-- ═══ Paso 2: matriz usuarios × campos ═══ -->
  <ng-container *ngIf="step === 'matrix'">
    <section class="bdur-toolbar">
      <button class="bdur-btn bdur-btn--ghost" (click)="backToSelect()">
        <mat-icon>arrow_back</mat-icon> Volver a la selección
      </button>
      <div class="bdur-toolbar__spacer"></div>
      <span class="bdur-summary">
        {{ selectedUsers.length }} usuarios · {{ targetsWithFields }} con campos marcados
      </span>
    </section>

    <!-- Advertencia: hay usuarios seleccionados sin campos marcados.
         No se les va a crear solicitud — el operador puede tildar
         algo o quitarlos de la selección. -->
    <section *ngIf="hasUsersWithoutFields" class="bdur-warning-banner">
      <mat-icon>info</mat-icon>
      <div class="bdur-warning-banner__text">
        <strong>{{ usersWithoutFields.length }} usuario(s) sin campos marcados</strong>
        <span>
          Si seguís así, a estos clientes no se les creará ninguna solicitud.
          Marcá al menos un campo o sacalos de la selección.
        </span>
        <ul class="bdur-warning-banner__list">
          <li *ngFor="let u of usersWithoutFields.slice(0, 6)">
            {{ displayUserShort(u) }}
          </li>
          <li *ngIf="usersWithoutFields.length > 6">
            ...y {{ usersWithoutFields.length - 6 }} más
          </li>
        </ul>
      </div>
    </section>

    <section class="bdur-form">
      <div class="bdur-form__row">
        <label class="bdur-label">
          Plazo límite (común a todos)
          <input
            type="date"
            [(ngModel)]="deadlineAt"
            [min]="todayIso"
            class="bdur-input"
            onclick="this.showPicker && this.showPicker()"
            onfocus="this.showPicker && this.showPicker()"
          />
        </label>
        <label class="bdur-label bdur-label--grow">
          Motivo (visible para los clientes)
          <textarea
            [(ngModel)]="motivo"
            rows="3"
            class="bdur-input bdur-textarea"
          ></textarea>
        </label>
      </div>
    </section>

    <section class="bdur-matrix-wrap">
      <table class="bdur-matrix">
        <thead>
          <tr>
            <th class="bdur-matrix__user-col">Usuario</th>
            <th
              *ngFor="let f of allFields"
              (click)="toggleColumn(f)"
              class="bdur-matrix__col-header"
              [title]="'Click para marcar/desmarcar ' + labelOfField(f) + ' a todos'"
            >
              <input
                type="checkbox"
                [checked]="columnState(f) === 'full'"
                [indeterminate]="columnState(f) === 'partial'"
                (click)="$event.stopPropagation()"
                (change)="toggleColumn(f)"
              />
              <span class="bdur-matrix__col-label">{{ labelOfField(f) }}</span>
              <span class="bdur-matrix__col-tag" *ngIf="f.companyOnly">empresa</span>
              <span class="bdur-matrix__col-tag" *ngIf="f.requiresCompliance" title="No se pide a clientes rechazados ni en blacklist">compliance</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let u of selectedUsers"
            class="bdur-matrix__row"
            [class.bdur-matrix__row--error]="!!errorForUser(u.usuarioId)"
            [class.bdur-matrix__row--empty]="isRowEmpty(u.usuarioId)"
          >
            <td class="bdur-matrix__user-col">
              <div class="bdur-matrix__user">
                <strong>{{ u.nombre }} {{ u.apellidos }}</strong>
                <small>#{{ u.usuarioId }} · {{ u.numeroId }}</small>
                <span class="bdur-badge" *ngIf="u.tipoUsuarioId === 1">Empresa</span>
                <span
                  *ngIf="isRowEmpty(u.usuarioId)"
                  class="bdur-row-empty-tag"
                  title="No tiene campos marcados — será omitido del envío"
                >
                  Sin campos
                </span>
              </div>
              <div *ngIf="errorForUser(u.usuarioId)" class="bdur-matrix__row-error">
                <mat-icon>error_outline</mat-icon>
                {{ errorForUser(u.usuarioId) }}
              </div>
            </td>
            <td
              *ngFor="let f of allFields"
              class="bdur-matrix__cell"
              [class.bdur-matrix__cell--disabled]="isCellDisabled(u, f)"
            >
              <div class="bdur-matrix__cell-content">
                <!-- Checkbox + valor inline. El label sigue siendo el
                     trigger del toggle. Si la celda está deshabilitada
                     (campo no aplica al usuario), el checkbox queda
                     disabled pero el dato/thumb SÍ se ve. -->
                <label
                  class="bdur-matrix__cell-check"
                  [class.bdur-matrix__cell-check--disabled]="isCellDisabled(u, f)"
                >
                  <input
                    type="checkbox"
                    [checked]="isCellSelected(u.usuarioId, f.fieldKey)"
                    [disabled]="isCellDisabled(u, f)"
                    (change)="toggleCell(u.usuarioId, f.fieldKey)"
                  />
                  <!-- Prefijo telefónico: bandera + label "Chile (+56)"
                       (alineado con la UX del select del cliente). -->
                  <span
                    *ngIf="isPhonePrefixField(f.fieldKey)"
                    class="bdur-matrix__phone-prefix"
                  >
                    <img
                      *ngIf="phonePrefixFlagFor(u) as flag"
                      [src]="flag"
                      alt="Bandera"
                      class="bdur-matrix__phone-flag"
                    />
                    <span
                      class="bdur-matrix__current"
                      [class.bdur-matrix__current--empty]="!phonePrefixLabelFor(u)"
                    >
                      {{ phonePrefixLabelFor(u) || 'Sin dato' }}
                    </span>
                  </span>

                  <!-- Otros campos escalares -->
                  <ng-container
                    *ngIf="!isFileField(f.fieldKey) && !isPhonePrefixField(f.fieldKey)"
                  >
                    <span
                      class="bdur-matrix__current"
                      [class.bdur-matrix__current--empty]="!currentValueOf(u, f.fieldKey)"
                    >
                      {{ currentValueOf(u, f.fieldKey) || 'Sin dato' }}
                    </span>
                  </ng-container>

                  <span
                    *ngIf="isFileField(f.fieldKey) && !currentDocUrlOf(u, f.fieldKey)"
                    class="bdur-matrix__thumb bdur-matrix__thumb--empty"
                    title="Sin vista previa"
                  >
                    <mat-icon>image_not_supported</mat-icon>
                  </span>
                </label>

                <!-- Thumbnail clickeable AFUERA del label — siempre
                     visible si hay URL, incluso si la celda está
                     deshabilitada para solicitar. El operador puede
                     querer ver el archivo actual del cliente aunque
                     no se pueda incluir en esta solicitud. -->
                <button
                  *ngIf="isFileField(f.fieldKey) && currentDocUrlOf(u, f.fieldKey) as url"
                  type="button"
                  class="bdur-matrix__thumb bdur-matrix__thumb--clickable"
                  (click)="previewDocument(url, $event)"
                  title="Ver documento en grande"
                >
                  <img [src]="url" alt="Documento actual" />
                  <span class="bdur-matrix__thumb-zoom">
                    <mat-icon>zoom_in</mat-icon>
                  </span>
                </button>

                <span
                  *ngIf="isCellDisabled(u, f)"
                  class="bdur-matrix__cell-na-tag"
                  title="Este campo no se puede solicitar a este usuario"
                >
                  No aplica
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <footer class="bdur-actions">
      <button class="bdur-btn bdur-btn--ghost" (click)="cancel()" [disabled]="saving">
        Cancelar
      </button>
      <button
        class="bdur-btn bdur-btn--primary"
        (click)="submitBulk()"
        [disabled]="saving || targetsWithFields === 0"
      >
        <mat-spinner *ngIf="saving" diameter="16"></mat-spinner>
        <mat-icon *ngIf="!saving">send</mat-icon>
        Crear {{ targetsWithFields }} solicitud(es)
        <span
          *ngIf="hasUsersWithoutFields"
          class="bdur-btn-tag"
          title="Hay usuarios seleccionados que no tienen campos marcados — serán omitidos"
        >
          {{ usersWithoutFields.length }} omitido(s)
        </span>
      </button>
    </footer>
  </ng-container>

  <!-- Lightbox fullscreen para previsualizar documentos actuales. -->
  <div
    *ngIf="lightboxUrl"
    class="bdur-lightbox"
    (click)="closeLightbox()"
    role="dialog"
    aria-modal="true"
  >
    <button
      type="button"
      class="bdur-lightbox__close"
      (click)="$event.stopPropagation(); closeLightbox()"
      aria-label="Cerrar"
    >
      <mat-icon>close</mat-icon>
    </button>
    <img
      [src]="lightboxUrl"
      alt="Documento actual"
      class="bdur-lightbox__img"
      (click)="$event.stopPropagation()"
    />
  </div>
</div>
